/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralParcelSubject } from './nonCadastralParcelSubject.model';
import { NonCadastralSource } from './nonCadastralSource.model';


export interface NonCadastralParcelContractEntity { 
    cadastralParcelId?: number;
    cislKod?: number;
    cislNazev?: string;
    delivered?: boolean;
    distinctChar: string;
    drupozKod?: number;
    drupozNazev?: string;
    id?: number;
    katuzeKod?: number;
    katuzeNazev?: string;
    koeficient?: number;
    lv?: number;
    parType?: string;
    parcelSubjects?: Array<NonCadastralParcelSubject>;
    parcis?: string;
    parcisDil?: number;
    parcisKmen?: number;
    parcisPod?: number;
    prumernaCena?: number;
    source?: NonCadastralSource;
    uniqueId?: string;
    vymera?: number;
    zpvypoKod?: number;
    zpvypoNazev?: string;
}
export namespace NonCadastralParcelContractEntity {
}


